import React from 'react';
type Tone = 'light' | 'dark';
export function Eyebrow({
  children,
  tone = 'light',
  align = 'center'
}: {
  children: React.ReactNode;
  tone?: Tone;
  align?: 'center' | 'left';
}) {
  return <p className={`mb-2 text-[11px] font-extrabold uppercase tracking-[.18em] md:text-xs ${align === 'center' ? 'text-center' : 'text-left'} ${tone === 'dark' ? 'text-gold-light' : 'text-gold-dark'}`} data-id="element-242" data-mp="2vxarwwrr3qtv">
      {children}
    </p>;
}
export function SectionTitle({
  children,
  tone = 'light'
}: {
  children: React.ReactNode;
  tone?: Tone;
}) {
  return <h2 className={`mx-auto max-w-4xl text-center text-2xl font-black uppercase leading-tight md:text-4xl ${tone === 'dark' ? 'text-white' : 'text-brand-deep'}`} data-id="element-243" data-mp="30y8bndsessxh">
      {children}
    </h2>;
}
export function SectionLead({
  children,
  tone = 'light'
}: {
  children: React.ReactNode;
  tone?: Tone;
}) {
  return <p className={`mx-auto mt-4 max-w-2xl text-center text-base leading-relaxed md:text-lg ${tone === 'dark' ? 'text-white/80' : 'text-slate-600'}`} data-id="element-244" data-mp="1ggadduc2bwi8">
      {children}
    </p>;
}
export function Mark({
  children
}: {
  children: React.ReactNode;
}) {
  return <span className="bg-gold-light box-decoration-clone px-1.5 text-brand-deep" data-id="element-245" data-mp="29i9y3udmbct7">{children}</span>;
}